import { useEffect, useRef, useState } from "react";
import { useCuepointsStore } from "../../animator/useCuepointsStore";
import { Button, Flex, Space, Typography } from "antd";
import {
  CheckCircleFilled,
  CheckCircleOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useTranslate } from "@refinedev/core";
import { useAntTheme } from "hooks/useAntTheme";
import { radius } from "@libertify/ui";

export const LiveHintWindow = ({
  isScriptClicked,
  isHtml,
}: {
  isScriptClicked: boolean;
  isHtml: boolean;
}) => {
  const scriptHasEverBeenClicked = useRef(false);

  if (isScriptClicked) {
    scriptHasEverBeenClicked.current = true;
  }
  const { updateCount } = useCuepointsStore((store) => ({
    updateCount: store.updateCount,
  }));
  const [close, setClose] = useState(true);
  const t = useTranslate();
  const prefix = isHtml ? "Web" : "";
  const title = t(`components.binder.index.howToCreate`);
  const toStartText = t(`components.binder.index.toStart${prefix}`);
  const toChooseText = t(`components.binder.index.toChoose${prefix}`);
  const { theme } = useAntTheme();
  const isHighlightCreated =
    scriptHasEverBeenClicked.current && updateCount !== 0;
  useEffect(() => {
    setTimeout(() => {
      setClose(false);
    }, 2000);
  }, []);

  useEffect(() => {
    if (isHighlightCreated) {
      setTimeout(() => {
        setClose(true);
      }, 3000);
    }
  }, [isHighlightCreated]);

  return (
    <>
      {close ? null : (
        <Flex
          style={{
            position: "fixed",
            bottom: 150,
            right: 24,
            width: 400,
            backgroundColor: "#000",
            padding: "10px",
            borderRadius: radius.box,
            boxSizing: "border-box",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            zIndex: 1000,
          }}
          vertical
          gap={10}
        >
          <Flex justify="space-between">
            <Typography.Text strong style={{ color: "#fff" }}>
              {title}
            </Typography.Text>
            <Button
              type="text"
              size="small"
              icon={<CloseOutlined style={{ color: theme.colorWhite }} />}
              onClick={() => setClose(true)}
            />
          </Flex>
          <Typography.Text style={{ color: theme.colorWhite }}>
            <Space>
              <CheckedIcon checked={scriptHasEverBeenClicked.current} />
              <span>{toStartText}</span>
            </Space>
          </Typography.Text>

          {toChooseText && (
            <Typography.Text style={{ color: theme.colorWhite }}>
              <Space>
                <CheckedIcon checked={isHighlightCreated} />
                <span>{toChooseText}</span>
              </Space>
            </Typography.Text>
          )}
        </Flex>
      )}
    </>
  );
};

const CheckedIcon = ({ checked }: { checked: boolean }) => {
  const { theme } = useAntTheme();
  if (checked)
    return (
      <CheckCircleFilled
        style={{
          color: theme.colorPrimary,
        }}
      />
    );

  return (
    <CheckCircleOutlined
      style={{
        color: theme.colorWhite,
      }}
    />
  );
};
